import React from 'react';
import { Image } from '@common-fe/common-fe';

import SidebarPlaceholder from '@/assets/placeholders/flows-sidebar.svg';
import { Option } from '@/common/types';
import { Stepper } from '@/components/elements';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

import {
  Content,
  Space, Title,   Wrapper, } from './StepperSidebar.styles';

export interface SidebarOption extends Option {
  active: boolean;
  focus: boolean;
}

interface Props {
  step: number;
  title?: string;
  options: Option[];
}

const StepperSidebar: React.FC<Props> = ({ step, title, options }) => (
  <Wrapper>
    <Content>
      <Title>{title}</Title>
      <Stepper options={options} activeKey={step} grey />
      <Space />
    </Content>
    {whiteLabelingConfig?.images?.reimburseMeSidebar !== '' && (
      <Image src={whiteLabelingConfig?.images?.reimburseMeSidebar || SidebarPlaceholder} alt="placeholder" />
    )}
  </Wrapper>
);

export default StepperSidebar;
